import { Link } from 'react-router-dom';
import {
  ArrowLeft,
  ArrowRight,
  Eye,
  Volume2,
  Link2,
  Wrench,
  Palette,
  HardHat,
  Timer,
  Target,
  Computer,
  CircleDot,
  Maximize2,
  Sun,
  Building2,
} from 'lucide-react';

import './EmergencyBoardStandalone.css';

const EmergencyBoardStandalone = () => {
  const features = [
    {
      Icon: Eye,
      title: '高い視認性',
      desc: '高輝度LEDにより、昼夜を問わず見やすい表示に対応。',
    },
    {
      Icon: Volume2,
      title: '緊急出動灯・音声の連動',
      desc: '緊急出動灯や音声アナウンスで、歩行者や一般車両へ注意を促します。',
    },
    {
      Icon: Link2,
      title: '連動制御',
      desc: 'LED表示・緊急出動灯・音声などの連動制御に対応。',
    },
    {
      Icon: Wrench,
      title: '設置環境に合わせた設計',
      desc: '設置場所や運用方法に合わせ、サイズ・表示内容・仕様を設計します。',
    },
    {
      Icon: Palette,
      title: 'オリジナルデザイン',
      desc: '消防署名・表示内容・本体デザインなど、ご要望に合わせて製作。',
    },
    {
      Icon: HardHat,
      title: '設計・製作・施工まで対応',
      desc: '設計・製作から設置工事、施工後の動作確認まで対応します。',
    },
  ];

  const customItems = [
    { Icon: CircleDot, label: '表示内容' },
    { Icon: Maximize2, label: '本体サイズ' },
    { Icon: Palette, label: 'カラー' },
    { Icon: Sun, label: 'LED表示' },
    { Icon: HardHat, label: '緊急出動灯' },
    { Icon: Volume2, label: '音声' },
    { Icon: Building2, label: '消防署名表示' },
  ];

  const lineup = [
    {
      model: 'HS-ST5100',
      type: '自立式',
      image: '/images/emergency-board/hs-st5100.png',
      desc: '消防署名などの表示に対応した自立式案内看板。',
    },
    {
      model: 'HS-SC3500',
      type: '自立式',
      image: '/images/emergency-board/hs-sc3500.png',
      desc: 'LED内部照明と施設名表示を組み合わせた自立式案内看板。',
    },
    {
      model: 'HS-SC3500D',
      type: '自立式',
      image: '/images/emergency-board/hs-sc3500d.png',
      desc: 'LED表示・緊急出動灯などを組み合わせた自立式案内看板。',
    },
  ];

  const systemSteps = [
  {
    Icon: Timer,
    label: <>タイマー・<br />外部機器</>,
  },
  {
    Icon: Target,
    label: <>専用<br />コントローラー</>,
  },
  {
    Icon: Volume2,
    label: <>LED表示・<br />警告灯・音声</>,
  },
  {
    Icon: Computer,
    label: <>PC（LAN）</>,
  },
];
  const specs = [
  ['本体寸法', '240mm（W）× 2000mm（H）× 102mm（D）'],
  ['表示画面', '160mm（W）× 1920mm（H）'],
  ['輝度', '4,500cd/㎡'],
  ['解像度', '16（横）× 192（縦）Pixels'],
  ['視野角', '水平＞160° / 垂直＞130°'],
  ['データ転送', 'LAN / USB'],
  ['電源', 'AC100V ±10% / 50〜60Hz'],
  ['消費電力', 'MAX 165W'],
  ['重量', '約10kg'],
  ['フレーム', 'アルミ・ブラック'],
  ['防水仕様', 'LEDモジュール防水'],
];
  const controllerBadges = [
  'LED表示制御',
  '警告灯・サイレン',
  '音声合成',
  'マイク入力',
  'タイマー機能',
  '10メッセージ呼び出し',
];

  const works = [
    {
      image: '/images/emergency-board/work-01.png',
      title: '消防署｜緊急出動案内看板【自立式】',
    },
    {
      image: '/images/emergency-board/work-02.png',
      title: '消防署｜緊急出動案内看板【自立式】',
    },
    {
      image: '/images/emergency-board/work-03.png',
      title: '消防署｜緊急出動案内看板【自立式】',
    },
  ];

  return (
    <main className="ebs-page">
      {/* ===== HERO ===== */}
      <section className="ebs-hero">
        <div className="container">
          <div className="ebs-hero-grid">
            <div className="ebs-hero-copy">
              <Link
                to="/products/emergency-board"
                className="ebs-back-btn"
              >
                <ArrowLeft size={14} strokeWidth={2} />
                緊急出動警報板へ戻る
              </Link>

              <div className="ebs-eyebrow">
                <span className="ebs-eyebrow-dot" />
                EMERGENCY BOARD
              </div>

              <h1>
                緊急出動案内看板【自立式】
              </h1>

              <div className="ebs-title-line" />

              <p className="ebs-hero-lead">
                消防署の出入口に設置し、「出動中」「緊急車両接近」などを
                LED表示・音声・<br />緊急出動灯で知らせ、歩行者や一般車両へ
                注意を促す自立式警報表示板。
              </p>

              <div className="ebs-hero-tags">
                <span>
                  <Eye size={15} />
                  高い視認性
                </span>

                <span>
                  <Volume2 size={15} />
                  緊急出動灯・音声連動
                </span>

                <span>
                  <Sun size={15} />
                  屋外対応
                </span>

                <span>
                  <Wrench size={15} />
                  設計・製作・施工まで対応
                </span>
              </div>
            </div>

            <div className="ebs-hero-image">
              <img
                src="/images/emergency-board/standalone-board.png"
                alt="緊急出動案内看板 自立式"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ===== FEATURES ===== */}
      <section className="section ebs-section">
        <div className="container">
          <SectionHeading
            eyebrow="FEATURES"
            title="この製品の特長"
          />

          <div className="ebs-feature-grid">
            {features.map(({ Icon, title, desc }) => (
              <article
                key={title}
                className="ebs-feature-card"
              >
                <div className="ebs-feature-icon">
                  <Icon size={21} strokeWidth={1.8} />
                </div>

                <div>
                  <h3>{title}</h3>
                  <p>{desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ===== CUSTOM DESIGN ===== */}
      <section className="section ebs-section ebs-section-soft">
        <div className="container">
          <SectionHeading
            eyebrow="CUSTOM DESIGN"
            title="設置環境に合わせたオーダー設計"
          />

          <p className="ebs-center-copy">
            消防署ごとの設置条件や運用方法に合わせ、表示内容・本体サイズ・緊急出動灯・<br />音声・制御方法などに対応します。
          </p>

          <div className="ebs-custom-list">
            {customItems.map(({ Icon, label }) => (
              <span
                key={label}
                className="ebs-custom-pill"
              >
                <Icon size={15} strokeWidth={1.8} />
                {label}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* ===== LINEUP ===== */}
      <section className="section ebs-section">
        <div className="container">
          <SectionHeading
            eyebrow="LINEUP"
            title="自立式ラインナップ"
          />

          <div className="ebs-lineup-grid">
            {lineup.map((item) => (
              <article
                key={item.model}
                className="ebs-lineup-card"
              >
                <div className="ebs-lineup-image">
                  <img
                    src={item.image}
                    alt={item.model}
                  />
                </div>

                <div className="ebs-lineup-body">
                  <h3>{item.model}</h3>

                  <span className="ebs-model-type">
                    {item.type}
                  </span>

                  <p>{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ===== SYSTEM ===== */}
      <section className="section ebs-section ebs-section-blue">
        <div className="container">
          <SectionHeading
            eyebrow="SYSTEM"
            title="システム構成・連動例"
          />

          <div className="ebs-system-grid">
            <div className="ebs-system-copy">
              <p>
                緊急出動時の運用に合わせ、LED表示・緊急出動灯・音声などを
                専用コントローラーで連動。
                タイマーや外部機器との組み合わせにも対応します。
              </p>

              <div className="ebs-system-flow">
                {systemSteps.map(
                  ({ Icon, label }, index) => (
                    <div
                      key={label}
                      className="ebs-system-step-wrap"
                    >
                      <div className="ebs-system-step">
                        <Icon
                          size={21}
                          strokeWidth={1.7}
                        />
                        <span>{label}</span>
                      </div>

                      {index < systemSteps.length - 1 && (
                        <span className="ebs-system-arrow">
                          →
                        </span>
                      )}
                    </div>
                  )
                )}
              </div>
            </div>

            <div className="ebs-system-image">
              <img
                src="/images/emergency-board/system-diagram.png"
                alt="緊急出動案内システム 構成例"
              />
            </div>
          </div>

          <p className="ebs-small-note">
            ※システム構成・配線方法は設置環境により異なります。
          </p>
        </div>
      </section>

      {/* ===== SPEC ===== */}
      <section className="section ebs-section">
        <div className="container">
          <div className="ebs-spec-heading">
            <span>SPEC</span>
            <h2>主要仕様 <small>（LED表示部 仕様例）</small></h2>
          </div>

          <div className="ebs-spec-layout">
            <div className="ebs-spec-drawing">
              <img
                src="/images/emergency-board/spec-drawing.png"
                alt="緊急出動案内看板 寸法図"
              />
            </div>

            <div className="ebs-spec-table">
              {specs.map(([label, value]) => (
                <div
                  className="ebs-spec-row"
                  key={label}
                >
                  <div className="ebs-spec-label">
                    {label}
                  </div>

                  <div className="ebs-spec-value">
                    {value}
                  </div>
                </div>
              ))}
            </div>

            <aside className="ebs-controller-card">
              <h3>専用コントローラーHS-201</h3>

              <div className="ebs-controller-image">
                <img
                  src="/images/emergency-board/controller.png"
                  alt="緊急出動案内システム 専用コントローラー"
                />
              </div>

              <div className="ebs-controller-badges">
                {controllerBadges.map((badge) => (
                  <span key={badge}>
                    {badge}
                  </span>
                ))}
              </div>

              <Link
                to="/contact"
                className="ebs-controller-btn"
              >
                詳細について相談する
                <ArrowRight size={14} strokeWidth={2} />
              </Link>
            </aside>
          </div>

          <p className="ebs-small-note">
            ※仕様は一例です。表示内容・設置条件により仕様が異なります。
          </p>
        </div>
      </section>

      {/* ===== WORKS ===== */}
      <section className="section ebs-section ebs-section-soft">
        <div className="container">
          <div className="ebs-works-heading">
            <span>WORKS</span>
            <h2>施工事例</h2>
          </div>

          <div className="ebs-works-grid">
            {works.map((work) => (
              <article
                key={work.image}
                className="ebs-work-card"
              >
                <img
                  src={work.image}
                  alt={work.title}
                />
                <p>{work.title}</p>
              </article>
            ))}
          </div>

          <div className="ebs-bottom-back-wrap">
            <Link
              to="/products/emergency-board"
              className="ebs-back-btn ebs-back-btn-light"
            >
              <ArrowLeft size={14} strokeWidth={2} />
              緊急出動警報板へ戻る
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

const SectionHeading = ({ eyebrow, title }) => (
  <div className="ebs-section-heading">
    <span>{eyebrow}</span>
    <h2>{title}</h2>
  </div>
);

export default EmergencyBoardStandalone;